require("../vendor/scrollify");

$(() => {
  const $window = $(window);
  const $document = $(document);

  const body = $("body");
  $.scrollify({
    section: ".bs-section--scroll-enable",
    interstitialSection: ".footer",
    easing: "easeOutExpo",
    offset: 1,
    scrollSpeed: 1100,
    scrollbars: true,
    standardScrollElements: ".footer",
    setHeights: false,
    overflowScroll: true,
    updateHash: false,
  });

  const windowWidth = $window.width();
  if (windowWidth > 767) {
    $.scrollify.enable();
    body.addClass("overflow-enable");
  } else {
    $.scrollify.disable();
    body.removeClass("overflow-enable");
  }

  $window.on("resize", function () {
    const windowWidth = $window.width();
    if (windowWidth > 767) {
      $.scrollify.enable();
      body.addClass("overflow-enable");
    } else {
      $.scrollify.disable();
      body.removeClass("overflow-enable");
    }
  });
  $window.on("scroll", function () {
    if ($window.scrollTop() + $window.height() == $document.height()) {
      $(".scroll-footer-down-btn").fadeOut();
    } else {
      $(".scroll-footer-down-btn").fadeIn();
    }
  });
});
